import { toast } from "react-toastify"
import { UserTrackShareForm } from "../../../../../../types"
import { errorFilledToastOptions } from "../../../../../../constants"

const adminTrackValidator = (formValues: UserTrackShareForm) => {
  const errors: any = {}

  if (!formValues.track) {
    errors.track = "You must select a track"
    toast.error("You must select a track", errorFilledToastOptions)
  }
  if (!formValues.mainOwner) {
    if (!formValues.share) {
      errors.share = "You must enter share"
      toast.error("You must enter share", errorFilledToastOptions)
    } else if (!/^\d*\.?\d*$/.test(formValues.share)) {
      errors.share = "You must enter a number"
      toast.error("You must enter a number", errorFilledToastOptions)
    } else if (Number(formValues.share) > 100) {
      errors.share = "Share can't be greater that 100"
      toast.error("Share can't be greater that 100", errorFilledToastOptions)
    }
    if (!formValues.mainOwner && formValues.roles?.length === 0) {
      errors.roles = "You must select a role"
      toast.error("You must select a role", errorFilledToastOptions)
    }
  }

  return errors
}

export default adminTrackValidator
